// @react-native-aria/overlays doesn't export PlacementAxis
import type { PlacementAxis } from '@react-aria/overlays'

import type { TOverlayPlacement } from './toReactAriaPlacement'

export const getShouldUseAxisPlacement = (axisPlacement: PlacementAxis, overlayPlacement: TOverlayPlacement) => {
  if (overlayPlacement.includes('-')) {
    const [position] = overlayPlacement.split('-')

    if (position.includes(axisPlacement)) {
      return false
    }
  }

  return true
}
